import { url } from './apiurl';
const isId = value => typeof value === 'string' && /^[a-f\d]{24}$/i.test(value);
let memoryVisitor;
const makeId = () => window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
function visitorId() {
  if (memoryVisitor) return memoryVisitor;
  try {
    const saved = localStorage.getItem('package-analytics-visitor');
    memoryVisitor = saved && /^[a-zA-Z0-9_-]{16,100}$/.test(saved) ? saved : makeId();
    localStorage.setItem('package-analytics-visitor', memoryVisitor);
  } catch (_) { memoryVisitor = makeId(); }
  return memoryVisitor;
}
// Independent, anonymous, best-effort telemetry. Never use the auth response handler.
export function trackPackageEvent(type, payload = {}) {
  try {
    if (type !== 'search' && !isId(payload.productId)) return;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 4000);
    fetch(`${url}/package-analytics/events`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: controller.signal,
      body: JSON.stringify({ ...payload, type, visitorId: visitorId(), eventKey: makeId() }),
    }).catch(() => {}).finally(() => clearTimeout(timer));
  } catch (_) { /* Telemetry must never interrupt the storefront. */ }
}
export function trackPackageSearch(query, resultCount, zoneId) {
  if (typeof query !== 'string' || !query.trim() || !Number.isFinite(Number(resultCount))) return;
  trackPackageEvent('search', { query: query.trim().slice(0, 120), resultCount: Math.max(0, Math.floor(Number(resultCount))), ...(isId(zoneId) ? { zoneId } : {}) });
}
